<template>
  <div class="exchange_user">
    <h3>신청자</h3>
    <p class="description">
      현금 캐시백의 경우 소득신고가 필요하며, 소득신고를 위하여 최초 1회 주민등록번호를 수집합니다.
    </p>
    <dl>
      <dt>이름</dt>
      <dd>{{ exchangeInit.userName }}</dd>
    </dl>
    <dl v-if="!userInfo.isCheckedIdNo || userInfo.businessType !== 1">
      <!--    <dl>-->
      <dt>주민등록번호</dt>
      <dd class="form for_idno">
        <v-input-number v-model="identityNoFront" @custom-input="checkPrevIdentityNo" maxlength="6" />
        <span>-</span>
        <v-input-number
          type="password"
          v-model="identityNoBack"
          maxlength="7"
          @custom-enter="handleClick"
          @custom-input="checkPrevIdentityNo"
        />
        <v-button class="btn04" @handleClick="handleClick" text="인증" :disabled="isState" />
      </dd>
      <dd class="msg" :class="msgClass">
        <v-icon clsName="icon_check" />
        <v-icon clsName="icon_error" />
        {{ errorMsg }}
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VInputNumber from '@/components/atoms/VInputNumber/index.vue';
import VButton from '@/components/atoms/VButton/index.vue';
import VIcon from '@/components/atoms/VIcon/index.vue';

export default {
  components: { VIcon, VButton, VInputNumber },
  computed: {
    ...mapGetters('exchange', ['exchangeInit']),
    ...mapGetters('userInfo', ['userInfo']),
    identityNo() {
      return this.identityNoFront + this.identityNoBack;
    },
    msgClass() {
      let className = '';
      if (this.errorCode === 0) {
        className = 'blue';
      } else if (this.errorCode > 0) {
        className = 'red';
      }
      return className;
    },
  },
  data() {
    return {
      errorMsg: '',
      errorCode: '',
      identityNoFront: '',
      identityNoBack: '',
      request: {},
      isState: false,
    };
  },
  methods: {
    ...mapActions('userInfo', ['checkIdentityNo', 'checkIdentityNoInCreate']),
    updateIdentityNo() {
      this.$emit('update', {
        request: this.isState ? this.request : '{}',
        isState: this.isState,
        idNo: this.identityNo,
      });
    },
    checkPrevIdentityNo() {
      if (this.isState === true && this.request.idNo !== this.identityNo) {
        this.isState = false;
        this.updateIdentityNo();
        this.errorCode = 100;
        this.errorMsg = '주민등록번호가 변경 되어 다시 인증하셔야 합니다.';
      }
    },
    async handleClick() {
      if (this.identityNo.length !== 13) {
        this.errorCode = 100;
        this.errorMsg = '주민등록번호가 일치하지 않습니다.';
        return;
      }
      const apiReturn = await this.checkIdentityNoInCreate(this.identityNo, { isCreate: true });
      this.errorCode = apiReturn.code;
      if (apiReturn.code > 0) {
        this.errorMsg = '회원정보와 입력하신 주민등록번호가 일치하지 않습니다.';
      } else if (apiReturn.code === 0) {
        this.errorMsg = '주민등록번호 확인 되었습니다.';
        this.request.idNo = this.identityNo;
        this.isState = true;
        this.updateIdentityNo();
      }
    },
  },
  mounted() {
    if (this.userInfo.isCheckedIdNo) {
      this.$emit('update', {
        isState: true,
      });
    }
  },
};
</script>
<style lang="scss">
.exchange_user {
  .for_idno {
    input {
      width: 150px;
    }
  }
  span {
    margin: 0 5px;
    color: #707070;
  }
  .btn04 {
    margin-left: 10px;
  }
}
</style>
